/**
 * Общие стили экзаменационного скина: их делят ExamView (обычный тест)
 * и MockExamView (пробники NBME). Токены — в examTokens.js.
 */
import { T } from './examTokens';

export const page = {
    display: 'flex', flexDirection: 'column', height: '100dvh',
    background: T.color.page, overflow: 'hidden', maxWidth: '100vw',
};

/** Телефон: панели плотнее, содержимое не должно уезжать за край. */
export const barMobile = { gap: 4, padding: '6px 6px', minWidth: 0 };

export const mobileNav = {
    display: 'flex', overflowX: 'auto', flex: '0 0 auto',
    background: T.color.navZebraEven, borderBottom: `1px solid ${T.color.navBorder}`,
    scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch',
};

export const mobileNavItem = {
    flex: '0 0 auto', minWidth: 44, height: 40, padding: '0 8px',
    display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2,
    border: 'none', cursor: 'pointer', fontFamily: T.font,
    fontSize: 15, color: T.color.navNumber,
};

export const mobileNavDot = { width: 6, height: 6, borderRadius: 3 };

export const bar = (side) => ({
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: 16, flex: '0 0 auto',
    padding: side === 'top' ? T.layout.barPaddingTop : T.layout.barPaddingBottom,
    background: T.color.bar, color: T.color.barText,
    [side === 'top' ? 'borderBottom' : 'borderTop']: `1px solid ${T.color.barLine}`,
});

export const barBtn = {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    background: 'transparent', border: 'none', color: T.color.barText,
    padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontFamily: T.font,
};

/** Кнопка-инструмент: иконка сверху, подпись снизу — раскладка эталона. */
export const toolBtn = {
    display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 2,
    background: 'transparent', border: 'none', color: T.color.barText,
    padding: '2px 8px', borderRadius: 4, cursor: 'pointer', fontFamily: T.font,
};

export const srOnly = {
    position: 'absolute', width: 1, height: 1, padding: 0, margin: -1,
    overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: 0,
};

export const radioDot = {
    width: T.layout.radio, height: T.layout.radio, flex: `0 0 ${T.layout.radio}px`,
    borderRadius: '50%', border: '1px solid',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
};

export const radioInner = {
    width: T.layout.radioDot, height: T.layout.radioDot,
    borderRadius: '50%', background: T.color.accent,
};

export const navCol = {
    flex: `0 0 ${T.layout.navWidth}px`, width: T.layout.navWidth,
    overflowY: 'auto', background: T.color.navZebraEven,
    borderRight: `1px solid ${T.color.navBorder}`,
};

export const navItem = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    width: '100%', height: T.layout.navRow, boxSizing: 'border-box',
    padding: T.layout.navRowPadding,
    border: 'none', textAlign: 'left', cursor: 'pointer', fontFamily: T.font,
};

export const mainCol = {
    flex: 1, overflowY: 'auto', background: T.color.surface,
    lineHeight: 1.625,
};

export const optionsCard = {
    border: `1px solid ${T.color.cardBorder}`,
    borderRadius: T.layout.cardRadius, maxWidth: 720,
    padding: T.layout.cardPadding,
    display: 'flex', flexDirection: 'column', gap: T.layout.optionGap,
};

export const optionRow = {
    display: 'flex', alignItems: 'center', gap: 12, padding: 0,
};


export const actionBtn = {
    border: 'none', borderRadius: 2, padding: '8px 18px',
    color: '#FFF', fontFamily: T.font, fontWeight: 700, cursor: 'pointer',
};

export const ghostBtn = { background: 'transparent', border: `1px solid ${T.color.barMuted}`, fontWeight: 400 };
